import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, UpdateBeCompetitors } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateBeCompetitors } from '../businessEntityApi';

function* updateBeCompetitorsSaga(action: UpdateBeCompetitors) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<number[]> = yield call(updateBeCompetitors, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(
      businessEntityActionCreators.setCompetitors({ beId: action.payload.beId, competitorIds: response.value })
    );
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBeCompetitors() {
  yield takeEvery(BusinessEntityActionKeys.UPDATE_BE_COMPETITORS, updateBeCompetitorsSaga);
}
